import { AuthenticationResult, EventMessage, EventType, InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import * as React from "react";
import AuthErrorPage from "../AuthErrorPage/AuthErrorPage";
import PermissionTemplate from "../PermissionTemplate/PermissionTemplate";
import UserTracking from "../UserTracking/UserTracking";
import { msalInstance } from "../config/authConfig";

const loginCallback = (event: EventMessage) => {
  if (
    ([EventType.LOGIN_SUCCESS, EventType.ACQUIRE_TOKEN_SUCCESS, EventType.SSO_SILENT_SUCCESS] as EventType[]).includes(
      event.eventType
    ) &&
    event.payload
  ) {
    const { account } = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(account);
  }
};

const AuthProvider: React.FC = ({ children }) => {
  msalInstance.addEventCallback(loginCallback);

  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate errorComponent={AuthErrorPage} interactionType={InteractionType.Redirect}>
        <UserTracking />
        <PermissionTemplate>{children}</PermissionTemplate>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};

export default AuthProvider;
